import {
  UserSurveyData,
  UserSurveyVariant,
  UserSurveyTestResult,
  UseUserSurvey,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "userSurvey";

/**
 * Hook for the UserSurvey experiment.
 * Allows editing the values of surveyQuestion,
 * initialFinalTexts and millisecondsDelay through Monarch.
 */
const useUserSurvey: UseUserSurvey = () => {
  // Call the Monarch API to get the experiment result
  const { isLoading, value } = useMonarchRule<{
    data: UserSurveyData;
    variantCustomId: UserSurveyVariant;
  }>(CUSTOM_RULE_ID, {});

  // If still loading or no value returned, return loading state
  if (isLoading || !value) {
    return {
      isLoading,
    } as UserSurveyTestResult;
  }

  // Return the experiment result with proper typing
  const result = {
    isLoading: false,
    variant: value.variantCustomId,
    data: value.data,
  };

  return result;
};

export default useUserSurvey;
